import { render, staticRenderFns } from "./ReportHighlights.vue?vue&type=template&id=00beb825"
import script from "./ReportHighlights.vue?vue&type=script&lang=js"
export * from "./ReportHighlights.vue?vue&type=script&lang=js"
import style0 from "./ReportHighlights.vue?vue&type=style&index=0&id=00beb825&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports